module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid25_960x848.59a2c3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid25_960x848.jpg
// module id = 5pPJ
// module chunks = 0